import { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Header from "../../components/navbar/Header";
import Footer from "../../components/footer/Footer";
import { Helmet } from "react-helmet";
import CustomSlider from "../../components/CustomSlider";
import serviceBanner from "../../assets/mobile-banners/Gem_Web_Banners_Service.webp";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebase";

const servicemobileSlides = [
  {
    img: serviceBanner,
    alt: "service",
  },
];
function BookAService() {
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [model, setModel] = useState("");
  const [pickup, setPickup] = useState("");
  const [loading, setLoading] = useState(false);

  const pattern = /^[6-9][0-9]{6,9}$/;
  if (phone !== "" && phone.length === 10 && !pattern.test(phone)) {
    toast.error("Enter valid phone number", {
      theme: "colored",
    });
  }

  let navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    if (name !== "" && phone !== "" && model !== "") {
      const dataCollectionRef = collection(db, "enquiries");
      try {
        await addDoc(dataCollectionRef, {
          name: name,
          email: email,
          phone: phone,
          model: model,
          pickup: pickup,
          formType: "book-service",
          timestamp: serverTimestamp(),
        });
        navigate("/thank-you");
      } catch (error) {
        toast.error("Something went wrong");
      }
    }
    setLoading(false);
  }

  return (
    <>
      <Helmet>
        <meta name="title" content="" />
        <meta name="description" content="" />
      </Helmet>
      <Header />
      <div className="hidden md:block">
        <img
          src={require("../../assets/banners-3/Banners-Home-Page-2.jpg")}
          loading="lazy"
          className="w-full lg:h-[550px] object-cover"
          alt="inusrance banner"
        />
      </div>
      <div>
        <CustomSlider
          slides={servicemobileSlides}
          effect="fade"
          className="sm:hidden"
          imgClass="lg:mt-16"
        />
      </div>
      <div className="px-4 shadow sm:px-0">
        <p className="container py-4 mx-auto">
          <Link to="/">Home</Link> / Book a Service
        </p>
      </div>
      <div className="container px-5 py-16 mx-auto">
        <p className="text-2xl font-semibold text-red-500">
          Maruti Car Service
        </p>
        <form onSubmit={handleSubmit} className="mt-5 space-y-3">
          <div className="grid gap-3 lg:grid-cols-3 sm:grid-cols-2">
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Name <span className="text-red-500">*</span>
              </label>
              <input
                className="w-full h-10 px-3 border rounded-md outline-none focus:ring-red-500 focus:border-red-500"
                type="text"
                required
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Email
              </label>
              <input
                className="w-full h-10 px-3 border rounded-md outline-none focus:ring-red-500 focus:border-red-500"
                type="text"
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">
                Phone <span className="text-red-500">*</span>
              </label>
              <input
                className="w-full h-10 px-3 border rounded-md outline-none focus:ring-red-500 focus:border-red-500"
                type="text"
                maxLength="10"
                minLength="10"
                required
                value={phone}
                onChange={(e) =>
                  setPhone(
                    e.target.value.replace(/[^1-9 ]/g, "") &&
                      e.target.value.replace(/ /g, ""),
                  )
                }
              />
              {!pattern.test(phone) && phone.length === 10 ? (
                <small className="text-red-500">phone number is invalid</small>
              ) : (
                ""
              )}
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">
                Model <span className="text-red-500">*</span>
              </label>
              <select
                required
                onChange={(e) => setModel(e.target.value)}
                className="block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-red-500 focus:border-red-500 sm:text-sm"
              >
                <option>Select Model</option>
                <optgroup label="Arena">
                  <option value="Victoris">Maruti Victoris</option>
                  <option value="Alto K10">Maruti Alto K10</option>
                  <option value="Wagon R">Maruti Wagon R</option>
                  <option value="Celerio">Maruti New Celerio</option>
                  <option value="Swift">Maruti Swift</option>
                  <option value="Dzire">Maruti Dzire</option>
                  <option value="S-Presso">Maruti S-Presso</option>
                  <option value="Ertiga">Maruti Ertiga</option>
                  <option value="Brezza">Maruti New Brezza</option>
                  <option value="Eeco">Maruti Eeco</option>
                </optgroup>
                <optgroup label="Nexa">
                  <option value="e-vitara">Maruti E-Vitara</option>
                  <option value="Fronx">Maruti Fronx</option>
                  <option value="Jimny">Maruti Jimny</option>
                  <option value="XL6">Maruti XL6</option>
                  <option value="Baleno">Maruti Baleno</option>
                  <option value="Ignis">Maruti Ignis</option>
                  <option value="Grand Vitara">Maruti Grand Vitara</option>
                </optgroup>
                <optgroup label="Goods Carrier">
                  <option value="Super Carry">Super Carry</option>
                  <option value="Eeco Cargo">Eeco Cargo</option>
                </optgroup>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">
                Pickup
              </label>
              <select
                required
                onChange={(e) => setPickup(e.target.value)}
                className="block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-red-500 focus:border-red-500 sm:text-sm"
              >
                <option>Select</option>
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </select>
            </div>
          </div>
          <p className="text-gray-700">
            <span className="font-bold text-black">Disclaimer</span>: I agree
            that by clicking the ‘Submit’ button below, I am explicitly
            soliciting a call / Message from Gem Motor Pvt. Ltd or its
            Representatives on my ‘Mobile’
          </p>
          <div className="flex items-start">
            <input
              id="disclaimer"
              name="disclaimer"
              type="checkbox"
              className="w-4 h-4 rounded"
            />
            <div className="ml-2 text-sm">
              <label htmlFor="disclaimer" className="font-medium text-gray-700">
                Please Agree with Following Disclaimer
              </label>
            </div>
          </div>
          <button
            className="hover:bg-[#1D3A8A] bg-red-500 duration-500 text-white rounded py-2.5 px-5"
            type="submit"
            disabled={pattern.test(phone) && phone.length === 10 ? false : true}
          >
            {loading ? (
              <div className="flex items-center justify-center">
                <CgSpinner className="w-5 h-5 mr-2 text-white animate-spin" />
                Loading
              </div>
            ) : (
              "Submit"
            )}
          </button>
        </form>
      </div>
      <Footer />
    </>
  );
}

export default BookAService;
